import React from "react";
import styled from "styled-components";

const FormHeader = ({ children, ...props }) => {
  return (
    <Header {...props}>
      {children}
    </Header>
  );
};

const Header = styled.h2`
  color: var(--aia-bx-dark-blue);
  font-size: 24px;
  line-height: 36px;
  margin-top: 0px;
  margin-bottom: 24px;
`;

export default FormHeader;